import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class latestVideoService {
  private videoProducts = new BehaviorSubject<any>(null);
  constructor() {}

  setVideoProducts(data: any) {
    this.videoProducts.next(data);
  }
  getVideoProducts(): Observable<any> {
    // return this.videoProducts;
    return this.videoProducts.asObservable();
  }
}
